import { Grid, SystemStyleObject, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

export type FormStepDescriptionProps = {
  title: ReactNode;
  description?: ReactNode;
  styles?: {
    title?: SystemStyleObject;
    description?: SystemStyleObject;
  };
};

export function FormStepDescription({ title, description, styles }: FormStepDescriptionProps) {
  return (
    <Grid gap={2} mb={description ? 0 : '-4'}>
      <Text textStyle="p-lg" fontWeight="medium" color="text" {...styles?.title}>
        {title}
      </Text>
      {description ? (
        <Text color="textSecondary" {...styles?.description}>
          {description}
        </Text>
      ) : null}
    </Grid>
  );
}
